export const XIcon = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => (
  <svg
    className={className}
    onClick={onClick}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.269287 9.73081C0.147986 9.60956 0.0679282 9.4689 0.0291121 9.30884C-0.00970403 9.14393 -0.00970403 8.98145 0.0291121 8.82139C0.0679282 8.66133 0.14556 8.5231 0.262009 8.40669L3.6754 4.99454L0.262009 1.58967C0.14556 1.47326 0.0679282 1.33503 0.0291121 1.17497C-0.00970403 1.01491 -0.00970403 0.854856 0.0291121 0.694798C0.0679282 0.52989 0.147986 0.386807 0.269287 0.265551C0.385735 0.149145 0.524017 0.0715412 0.684134 0.0327392C0.849102 -0.0109131 1.01164 -0.0109131 1.17176 0.0327392C1.33673 0.0715412 1.47744 0.14672 1.59389 0.258276L5 3.67043L8.41339 0.265551C8.52984 0.149145 8.6657 0.0715412 8.82096 0.0327392C8.98108 -0.0109131 9.14119 -0.0109131 9.30131 0.0327392C9.46628 0.0715412 9.60699 0.15157 9.72344 0.272826C9.84959 0.389232 9.93207 0.52989 9.97089 0.694798C10.0097 0.854856 10.0097 1.01491 9.97089 1.17497C9.93207 1.33503 9.85201 1.47326 9.73071 1.58967L6.33188 4.99454L9.73071 8.40669C9.85201 8.5231 9.93207 8.66133 9.97089 8.82139C10.0097 8.98145 10.0097 9.14393 9.97089 9.30884C9.93207 9.4689 9.84959 9.60713 9.72344 9.72354C9.60699 9.84479 9.46628 9.92725 9.30131 9.9709C9.14119 10.0097 8.98108 10.0097 8.82096 9.9709C8.6657 9.9321 8.52984 9.85207 8.41339 9.73081L5 6.32594L1.59389 9.73809C1.47744 9.84964 1.33673 9.92725 1.17176 9.9709C1.01164 10.0097 0.849102 10.0097 0.684134 9.9709C0.524017 9.92725 0.385735 9.84722 0.269287 9.73081Z"
      fill="currentColor"
    />
  </svg>
);
